import { Nullable } from "../..";
import { IEntityCopyOptions } from "./entity-copy-options";
import { RelationCopyMethod } from "./relation-copy-method";

/**
 * Defines a relation copy option.
 */
export interface IRelationCopyOption {
    /**
     * Gets or sets the name of the relation.
     */
    name: string;

    /**
     * Gets or sets the copy method.
     */
    method: RelationCopyMethod;

    /**
     * Gets or sets the related copy options.
     */
    relatedCopyOptions: Nullable<IEntityCopyOptions>;
}

export class RelationCopyOption implements IRelationCopyOption {
    /**
     * {@inheritDoc}
     */
    name: string;

    /**
     * {@inheritDoc}
     */
    method: RelationCopyMethod;

    /**
     * {@inheritDoc}
     */
    relatedCopyOptions: Nullable<IEntityCopyOptions>;

    constructor(name: string, method: RelationCopyMethod, relatedCopyOptions: Nullable<IEntityCopyOptions> = null) {
        this.name = name;
        this.method = method;
        this.relatedCopyOptions = relatedCopyOptions ?? null;
    }
}
